import { createReducer } from '@reduxjs/toolkit';
import * as filtersCacheActions from './actions';
import {
  DICTIONARY_NAMES,
  DictionaryCache,
  FiltersCacheShape,
  MAX_ENTRIES_PER_DICTIONARY,
} from './model';

const initial: FiltersCacheShape = {
  project: {},
  category: {},
  extension: {},
  tag: {},
};

export const filtersCacheReducer = createReducer<FiltersCacheShape>(initial, (builder) =>
  builder
    .addCase(filtersCacheActions.stored, (s, a) => {
      const { dict, key, items } = a.payload;
      // Точный тип элементов задан парой dict/items в StoredPayload и уже проверен на
      // стороне вызова; внутри редьюсера словари обрабатываются единообразно.
      const cache = s[dict] as DictionaryCache<unknown>;

      // Вытесняем по давности обращения, а не вставки: сначала удаляем ключ, потом
      // добавляем заново, поэтому он оказывается в конце (у строковых ключей порядок в
      // объекте — порядок вставки).
      delete cache[key];
      if (Object.keys(cache).length >= MAX_ENTRIES_PER_DICTIONARY) {
        const oldestKey = Object.keys(cache)[0];
        if (oldestKey !== undefined) {
          delete cache[oldestKey];
        }
      }

      // Время записи ставим здесь, чтобы у кэша в памяти и у персиста был один источник
      // (по нему считается устаревание, см. isCacheStale).
      cache[key] = { items, storedAt: Date.now() };
    })
    .addCase(filtersCacheActions.hydrated, (s, a) => {
      // Гидрация из localStorage при старте. Не затираем записи, загруженные в этой
      // сессии (они свежее), — только добавляем отсутствующие.
      DICTIONARY_NAMES.forEach((dict) => {
        const persisted = a.payload.cache[dict] as DictionaryCache<unknown> | undefined;
        if (!persisted) {
          return;
        }
        const cache = s[dict] as DictionaryCache<unknown>;
        Object.entries(persisted).forEach(([key, entry]) => {
          if (!(key in cache)) {
            cache[key] = entry;
          }
        });
      });
    }),
);
